// Plan comptable OHADA - Comptes à 3 chiffres (Classes 1-7)
// Source: Acte Uniforme OHADA 2000

export const OHADA_ACCOUNTS = [
    // Classe 1 - Comptes de ressources durables
    { code: '101', libelle: 'Capital social' },
    { code: '102', libelle: 'Capital par dotation' },
    { code: '103', libelle: 'Capital personnel' },
    { code: '104', libelle: "Compte de l'exploitant" },
    { code: '105', libelle: 'Primes liées aux capitaux propres' },
    { code: '106', libelle: 'Écarts de réévaluation' },
    { code: '109', libelle: 'Actionnaires, capital souscrit, non appelé' },
    { code: '111', libelle: 'Réserve légale' },
    { code: '112', libelle: 'Réserves statutaires ou contractuelles' },
    { code: '113', libelle: 'Réserves réglementées' },
    { code: '118', libelle: 'Autres réserves' },
    { code: '121', libelle: 'Report à nouveau créditeur' },
    { code: '129', libelle: 'Report à nouveau débiteur' },
    { code: '130', libelle: "Résultat en instance d'affectation" },
    { code: '131', libelle: 'Résultat net : bénéfice' },
    { code: '132', libelle: 'Marge brute (MB)' },
    { code: '133', libelle: 'Valeur ajoutée (VA)' },
    { code: '134', libelle: "Excédent brut d'exploitation (EBE)" },
    { code: '135', libelle: "Résultat d'exploitation (RE)" },
    { code: '136', libelle: 'Résultat financier (RF)' },
    { code: '137', libelle: 'Résultat des activités ordinaires (RAO)' },
    { code: '138', libelle: 'Résultat hors activités ordinaires (RHAO)' },
    { code: '139', libelle: 'Résultat net : perte' },
    { code: '141', libelle: "Subventions d'équipement A" },
    { code: '142', libelle: "Subventions d'équipement B" },
    { code: '148', libelle: "Autres subventions d'investissement" },
    { code: '151', libelle: 'Amortissements dérogatoires' },
    { code: '152', libelle: 'Plus-values de cession à réinvestir' },
    { code: '153', libelle: 'Fonds réglementés' },
    { code: '154', libelle: 'Provision spéciale de réévaluation' },
    { code: '155', libelle: 'Provisions réglementées relatives aux immobilisations' },
    { code: '156', libelle: 'Provisions réglementées relatives aux stocks' },
    { code: '157', libelle: "Provisions pour investissement" },
    { code: '158', libelle: 'Autres provisions et fonds réglementés' },
    { code: '161', libelle: 'Emprunts obligataires' },
    { code: '162', libelle: 'Emprunts et dettes auprès des établissements de crédit' },
    { code: '163', libelle: "Avances reçues de l'État" },
    { code: '164', libelle: 'Avances reçues et comptes courants bloqués' },
    { code: '165', libelle: 'Dépôts et cautionnements reçus' },
    { code: '166', libelle: 'Intérêts courus' },
    { code: '167', libelle: 'Avances assorties de conditions particulières' },
    { code: '168', libelle: 'Autres emprunts et dettes' },
    { code: '172', libelle: 'Emprunts équivalents de crédit-bail immobilier' },
    { code: '173', libelle: 'Emprunts équivalents de crédit-bail mobilier' },
    { code: '176', libelle: 'Intérêts courus' },
    { code: '178', libelle: "Emprunts équivalents d'autres contrats" },
    { code: '181', libelle: 'Dettes liées à des participations' },
    { code: '182', libelle: 'Dettes liées à des sociétés en participation' },
    { code: '183', libelle: 'Intérêts courus sur dettes liées à des participations' },
    { code: '184', libelle: 'Comptes permanents bloqués des établissements et succursales' },
    { code: '185', libelle: 'Comptes permanents non bloqués des établissements et succursales' },
    { code: '186', libelle: 'Comptes de liaison charges' },
    { code: '187', libelle: 'Comptes de liaison produits' },
    { code: '188', libelle: 'Comptes de liaison des sociétés en participation' },
    { code: '191', libelle: 'Provisions pour litiges' },
    { code: '192', libelle: 'Provisions pour garanties données aux clients' },
    { code: '193', libelle: 'Provisions pour pertes sur marchés à achèvement futur' },
    { code: '194', libelle: 'Provisions pour pertes de change' },
    { code: '195', libelle: 'Provisions pour impôts' },
    { code: '196', libelle: 'Provisions pour pensions et obligations similaires' },
    { code: '197', libelle: 'Provisions pour charges à répartir sur plusieurs exercices' },
    { code: '198', libelle: 'Autres provisions financières pour risques et charges' },

    // Classe 2 - Comptes d'actif immobilisé
    { code: '201', libelle: "Frais d'établissement" },
    { code: '202', libelle: 'Charges à répartir sur plusieurs exercices' },
    { code: '206', libelle: 'Primes de remboursement des obligations' },
    { code: '211', libelle: 'Frais de recherche et de développement' },
    { code: '212', libelle: 'Brevets, licences, concessions et droits similaires' },
    { code: '213', libelle: 'Logiciels' },
    { code: '214', libelle: 'Marques' },
    { code: '215', libelle: 'Fonds commercial' },
    { code: '216', libelle: 'Droit au bail' },
    { code: '217', libelle: 'Investissements de création' },
    { code: '218', libelle: 'Autres droits et valeurs incorporels' },
    { code: '219', libelle: 'Immobilisations incorporelles en cours' },
    { code: '221', libelle: 'Terrains agricoles et forestiers' },
    { code: '222', libelle: 'Terrains nus' },
    { code: '223', libelle: 'Terrains bâtis' },
    { code: '224', libelle: 'Travaux de mise en valeur des terrains' },
    { code: '225', libelle: 'Terrains de gisement' },
    { code: '226', libelle: 'Terrains aménagés' },
    { code: '227', libelle: 'Terrains mis en concession' },
    { code: '228', libelle: 'Autres terrains' },
    { code: '229', libelle: 'Aménagements de terrains en cours' },
    { code: '231', libelle: 'Bâtiments industriels, agricoles, administratifs et commerciaux sur sol propre' },
    { code: '232', libelle: "Bâtiments industriels, agricoles, administratifs et commerciaux sur sol d'autrui" },
    { code: '233', libelle: "Ouvrages d'infrastructure" },
    { code: '234', libelle: 'Installations techniques' },
    { code: '235', libelle: 'Aménagements de bureaux' },
    { code: '237', libelle: 'Bâtiments industriels, agricoles et commerciaux mis en concession' },
    { code: '238', libelle: 'Autres installations et agencements' },
    { code: '239', libelle: 'Bâtiments et installations en cours' },
    { code: '241', libelle: 'Matériel et outillage industriel et commercial' },
    { code: '242', libelle: 'Matériel et outillage agricole' },
    { code: '243', libelle: "Matériel d'emballage récupérable et identifiable" },
    { code: '244', libelle: 'Matériel et mobilier' },
    { code: '245', libelle: 'Matériel de transport' },
    { code: '246', libelle: 'Immobilisations animales et agricoles' },
    { code: '247', libelle: 'Agencements et aménagements du matériel' },
    { code: '248', libelle: 'Autres matériels' },
    { code: '249', libelle: 'Matériel en cours' },
    { code: '251', libelle: 'Avances et acomptes versés sur immobilisations incorporelles' },
    { code: '252', libelle: 'Avances et acomptes versés sur immobilisations corporelles' },
    { code: '261', libelle: 'Titres de participation dans des sociétés sous contrôle exclusif' },
    { code: '262', libelle: 'Titres de participation dans des sociétés sous contrôle conjoint' },
    { code: '263', libelle: 'Titres de participation dans des sociétés conférant une influence notable' },
    { code: '265', libelle: 'Participations dans des organismes professionnels' },
    { code: '266', libelle: "Parts dans des groupements d'intérêt économique (GIE)" },
    { code: '268', libelle: 'Autres titres de participation' },
    { code: '271', libelle: 'Prêts et créances non commerciales' },
    { code: '272', libelle: 'Prêts au personnel' },
    { code: '273', libelle: 'Créances sur l\'État' },
    { code: '274', libelle: 'Titres immobilisés' },
    { code: '275', libelle: 'Dépôts et cautionnements versés' },
    { code: '276', libelle: 'Intérêts courus' },
    { code: '277', libelle: 'Créances rattachées à des participations et avances à des GIE' },
    { code: '278', libelle: 'Immobilisations financières diverses' },
    { code: '281', libelle: 'Amortissements des immobilisations incorporelles' },
    { code: '282', libelle: 'Amortissements des terrains' },
    { code: '283', libelle: 'Amortissements des bâtiments, installations techniques et agencements' },
    { code: '284', libelle: 'Amortissements du matériel' },
    { code: '291', libelle: 'Provisions pour dépréciation des immobilisations incorporelles' },
    { code: '292', libelle: 'Provisions pour dépréciation des terrains' },
    { code: '293', libelle: 'Provisions pour dépréciation des bâtiments, installations techniques et agencements' },
    { code: '294', libelle: 'Provisions pour dépréciation de matériel' },
    { code: '295', libelle: 'Provisions pour dépréciation des avances et acomptes versés sur immobilisations' },
    { code: '296', libelle: 'Provisions pour dépréciation des titres de participation' },
    { code: '297', libelle: 'Provisions pour dépréciation des autres immobilisations financières' },

    // Classe 3 - Comptes de stocks
    { code: '311', libelle: 'Marchandises A' },
    { code: '312', libelle: 'Marchandises B' },
    { code: '318', libelle: 'Marchandises hors activités ordinaires (HAO)' },
    { code: '321', libelle: 'Matières A' },
    { code: '322', libelle: 'Matières B' },
    { code: '323', libelle: 'Fournitures (A, B)' },
    { code: '331', libelle: 'Matières consommables' },
    { code: '332', libelle: "Fournitures d'atelier et d'usine" },
    { code: '333', libelle: 'Fournitures de magasin' },
    { code: '334', libelle: 'Fournitures de bureau' },
    { code: '335', libelle: 'Emballages' },
    { code: '338', libelle: 'Autres matières' },
    { code: '341', libelle: 'Produits en cours' },
    { code: '342', libelle: 'Travaux en cours' },
    { code: '343', libelle: 'Produits intermédiaires en cours' },
    { code: '344', libelle: 'Produits résiduels en cours' },
    { code: '351', libelle: 'Études en cours' },
    { code: '352', libelle: 'Prestations de services en cours' },
    { code: '361', libelle: 'Produits finis A' },
    { code: '362', libelle: 'Produits finis B' },
    { code: '371', libelle: 'Produits intermédiaires' },
    { code: '372', libelle: 'Produits résiduels' },
    { code: '381', libelle: 'Marchandises en cours de route' },
    { code: '382', libelle: 'Matières premières et fournitures liées en cours de route' },
    { code: '383', libelle: 'Autres approvisionnements en cours de route' },
    { code: '386', libelle: 'Produits finis en cours de route' },
    { code: '387', libelle: 'Stock en consignation ou en dépôt' },
    { code: '388', libelle: 'Stock provenant d\'immobilisations mises hors service ou au rebut' },
    { code: '391', libelle: 'Dépréciations des stocks de marchandises' },
    { code: '392', libelle: 'Dépréciations des stocks de matières premières et fournitures liées' },
    { code: '393', libelle: 'Dépréciations des stocks d\'autres approvisionnements' },
    { code: '394', libelle: 'Dépréciations des productions en cours' },
    { code: '395', libelle: 'Dépréciations des services en cours' },
    { code: '396', libelle: 'Dépréciations des stocks de produits finis' },
    { code: '397', libelle: 'Dépréciations des stocks de produits intermédiaires et résiduels' },
    { code: '398', libelle: 'Dépréciations des stocks en cours de route, en consignation ou en dépôt' },

    // Classe 4 - Comptes de tiers
    { code: '401', libelle: 'Fournisseurs, dettes en compte' },
    { code: '402', libelle: 'Fournisseurs, effets à payer' },
    { code: '408', libelle: 'Fournisseurs, factures non parvenues' },
    { code: '409', libelle: 'Fournisseurs débiteurs' },
    { code: '411', libelle: 'Clients' },
    { code: '412', libelle: 'Clients, effets à recevoir en portefeuille' },
    { code: '414', libelle: 'Créances sur cessions d\'immobilisations' },
    { code: '415', libelle: 'Clients, effets escomptés non échus' },
    { code: '416', libelle: 'Créances clients litigieuses ou douteuses' },
    { code: '418', libelle: 'Clients, produits à recevoir' },
    { code: '419', libelle: 'Clients créditeurs' },
    { code: '421', libelle: 'Personnel, avances et acomptes' },
    { code: '422', libelle: 'Personnel, rémunérations dues' },
    { code: '423', libelle: 'Personnel, oppositions, saisies-arrêts' },
    { code: '424', libelle: 'Personnel, œuvres sociales internes' },
    { code: '425', libelle: 'Représentants du personnel' },
    { code: '426', libelle: 'Personnel, participation aux bénéfices' },
    { code: '427', libelle: 'Personnel - dépôts' },
    { code: '428', libelle: 'Personnel, charges à payer et produits à recevoir' },
    { code: '431', libelle: 'Sécurité sociale' },
    { code: '432', libelle: 'Caisses de retraite complémentaire' },
    { code: '433', libelle: 'Autres organismes sociaux' },
    { code: '438', libelle: 'Organismes sociaux, charges à payer et produits à recevoir' },
    { code: '441', libelle: 'État, impôt sur les bénéfices' },
    { code: '442', libelle: 'État, autres impôts et taxes' },
    { code: '443', libelle: 'État, TVA facturée' },
    { code: '444', libelle: 'État, TVA due ou crédit de TVA' },
    { code: '445', libelle: 'État, TVA récupérable' },
    { code: '446', libelle: 'État, autres taxes sur le chiffre d\'affaires' },
    { code: '447', libelle: 'État, impôts retenus à la source' },
    { code: '448', libelle: 'État, charges à payer et produits à recevoir' },
    { code: '449', libelle: 'État, créances et dettes diverses' },
    { code: '451', libelle: 'Opérations avec les organismes africains' },
    { code: '452', libelle: 'Opérations avec les autres organismes internationaux' },
    { code: '458', libelle: 'Organismes internationaux, fonds de dotation et subventions à recevoir' },
    { code: '461', libelle: 'Associés, opérations sur le capital' },
    { code: '462', libelle: 'Associés, comptes courants' },
    { code: '463', libelle: 'Associés, opérations faites en commun' },
    { code: '465', libelle: 'Associés, dividendes à payer' },
    { code: '466', libelle: 'Groupe, comptes courants' },
    { code: '467', libelle: 'Actionnaires, restant dû sur capital appelé' },
    { code: '471', libelle: 'Comptes d\'attente' },
    { code: '472', libelle: 'Versements restant à effectuer sur titres non libérés' },
    { code: '474', libelle: 'Répartition périodique des charges et des produits' },
    { code: '475', libelle: 'Créances sur travaux non encore facturables' },
    { code: '476', libelle: 'Charges constatées d\'avance' },
    { code: '477', libelle: 'Produits constatés d\'avance' },
    { code: '478', libelle: 'Écarts de conversion - actif' },
    { code: '479', libelle: 'Écarts de conversion - passif' },
    { code: '481', libelle: 'Fournisseurs d\'investissements' },
    { code: '482', libelle: 'Fournisseurs d\'investissements, effets à payer' },
    { code: '483', libelle: 'Dettes sur acquisition de titres de placement' },
    { code: '484', libelle: 'Autres dettes hors activités ordinaires (HAO)' },
    { code: '485', libelle: 'Créances sur cessions d\'immobilisations' },
    { code: '486', libelle: 'Créances sur cessions de titres de placement' },
    { code: '488', libelle: 'Autres créances hors activités ordinaires (HAO)' },
    { code: '490', libelle: 'Dépréciations des comptes fournisseurs' },
    { code: '491', libelle: 'Dépréciations des comptes clients' },
    { code: '492', libelle: 'Dépréciations des comptes personnel' },
    { code: '493', libelle: 'Dépréciations des comptes organismes sociaux' },
    { code: '494', libelle: 'Dépréciations des comptes état et collectivités publiques' },
    { code: '495', libelle: 'Dépréciations des comptes organismes internationaux' },
    { code: '496', libelle: 'Dépréciations des comptes associés et groupe' },
    { code: '497', libelle: 'Dépréciations des comptes débiteurs divers' },
    { code: '498', libelle: 'Dépréciations des comptes de créances HAO' },
    { code: '499', libelle: 'Risques provisionnés' },

    // Classe 5 - Comptes de trésorerie
    { code: '501', libelle: 'Titres du trésor et bons de caisse à court terme' },
    { code: '502', libelle: 'Actions' },
    { code: '503', libelle: 'Obligations' },
    { code: '504', libelle: 'Bons de souscription' },
    { code: '505', libelle: 'Titres négociables hors région' },
    { code: '506', libelle: 'Intérêts courus' },
    { code: '508', libelle: 'Autres valeurs assimilées' },
    { code: '511', libelle: 'Effets à encaisser' },
    { code: '512', libelle: 'Effets à l\'encaissement' },
    { code: '513', libelle: 'Chèques à encaisser' },
    { code: '514', libelle: 'Chèques à l\'encaissement' },
    { code: '515', libelle: 'Cartes de crédit à encaisser' },
    { code: '518', libelle: 'Autres valeurs à l\'encaissement' },
    { code: '521', libelle: 'Banques locales' },
    { code: '522', libelle: 'Banques autres États région' },
    { code: '523', libelle: 'Banques autres États zone monétaire' },
    { code: '524', libelle: 'Banques hors zone monétaire' },
    { code: '526', libelle: 'Banques, intérêts courus' },
    { code: '531', libelle: 'Chèques postaux' },
    { code: '532', libelle: 'Trésor' },
    { code: '533', libelle: 'Sociétés de gestion et d\'intermédiation (SGI)' },
    { code: '536', libelle: 'Établissements financiers, intérêts courus' },
    { code: '538', libelle: 'Autres organismes financiers' },
    { code: '541', libelle: 'Options de taux d\'intérêt' },
    { code: '542', libelle: 'Options de taux de change' },
    { code: '543', libelle: 'Options de taux boursiers' },
    { code: '544', libelle: 'Instruments de marchés à terme' },
    { code: '545', libelle: 'Avoirs d\'or et autres métaux précieux' },
    { code: '561', libelle: 'Crédits de trésorerie' },
    { code: '564', libelle: 'Escompte de crédits de campagne' },
    { code: '565', libelle: 'Escompte de crédits ordinaires' },
    { code: '566', libelle: 'Banques, crédits de trésorerie, intérêts courus' },
    { code: '571', libelle: 'Caisse siège social' },
    { code: '572', libelle: 'Caisse succursale A' },
    { code: '573', libelle: 'Caisse succursale B' },
    { code: '581', libelle: 'Régies d\'avance' },
    { code: '582', libelle: 'Accréditifs' },
    { code: '585', libelle: 'Virements de fonds' },
    { code: '588', libelle: 'Autres virements internes' },
    { code: '590', libelle: 'Dépréciations des titres de placement' },
    { code: '591', libelle: 'Dépréciations des titres et valeurs à encaisser' },
    { code: '592', libelle: 'Dépréciations des comptes banques' },
    { code: '593', libelle: 'Dépréciations des comptes établissements financiers et assimilés' },
    { code: '594', libelle: 'Dépréciations des comptes d\'instruments de trésorerie' },
    { code: '599', libelle: 'Risques provisionnés à caractère financier' },

    // Classe 6 - Comptes de charges des activités ordinaires
    { code: '601', libelle: 'Achats de marchandises' },
    { code: '602', libelle: 'Achats de matières premières et fournitures liées' },
    { code: '603', libelle: 'Variations des stocks de biens achetés' },
    { code: '604', libelle: 'Achats stockés de matières et fournitures consommables' },
    { code: '605', libelle: 'Autres achats' },
    { code: '608', libelle: 'Achats d\'emballages' },
    { code: '611', libelle: 'Transports sur achats' },
    { code: '612', libelle: 'Transports sur ventes' },
    { code: '613', libelle: 'Transports pour le compte de tiers' },
    { code: '614', libelle: 'Transports du personnel' },
    { code: '616', libelle: 'Transports de plis' },
    { code: '618', libelle: 'Autres frais de transport' },
    { code: '621', libelle: 'Sous-traitance générale' },
    { code: '622', libelle: 'Locations et charges locatives' },
    { code: '623', libelle: 'Redevances de crédit-bail et contrats assimilés' },
    { code: '624', libelle: 'Entretien, réparations et maintenance' },
    { code: '625', libelle: 'Primes d\'assurance' },
    { code: '626', libelle: 'Études, recherches et documentation' },
    { code: '627', libelle: 'Publicité, publications, relations publiques' },
    { code: '628', libelle: 'Frais de télécommunications' },
    { code: '631', libelle: 'Frais bancaires' },
    { code: '632', libelle: 'Rémunérations d\'intermédiaires et de conseils' },
    { code: '633', libelle: 'Frais de formation du personnel' },
    { code: '634', libelle: 'Redevances pour brevets, licences, logiciels et droits similaires' },
    { code: '635', libelle: 'Cotisations' },
    { code: '637', libelle: 'Rémunérations de personnel extérieur à l\'entreprise' },
    { code: '638', libelle: 'Autres charges externes' },
    { code: '641', libelle: 'Impôts et taxes directs' },
    { code: '645', libelle: 'Impôts et taxes indirects' },
    { code: '646', libelle: 'Droits d\'enregistrement' },
    { code: '647', libelle: 'Pénalités et amendes fiscales' },
    { code: '648', libelle: 'Autres impôts et taxes' },
    { code: '651', libelle: 'Pertes sur créances clients et autres débiteurs' },
    { code: '652', libelle: 'Quote-part de résultat sur opérations faites en commun' },
    { code: '653', libelle: 'Quote-part de résultat annulée sur exécution partielle de contrats pluri-exercices' },
    { code: '654', libelle: 'Valeur comptable des cessions courantes d\'immobilisations' },
    { code: '658', libelle: 'Charges diverses' },
    { code: '659', libelle: 'Charges provisionnées d\'exploitation' },
    { code: '661', libelle: 'Rémunérations directes versées au personnel national' },
    { code: '662', libelle: 'Rémunérations directes versées au personnel non national' },
    { code: '663', libelle: 'Indemnités forfaitaires versées au personnel' },
    { code: '664', libelle: 'Charges sociales' },
    { code: '666', libelle: 'Rémunérations et charges sociales de l\'exploitant individuel' },
    { code: '667', libelle: 'Rémunération transférée de personnel extérieur' },
    { code: '668', libelle: 'Autres charges sociales' },
    { code: '671', libelle: 'Intérêts des emprunts' },
    { code: '672', libelle: 'Intérêts dans loyers de crédit-bail et contrats assimilés' },
    { code: '673', libelle: 'Escomptes accordés' },
    { code: '674', libelle: 'Autres intérêts' },
    { code: '675', libelle: 'Escomptes des effets de commerce' },
    { code: '676', libelle: 'Pertes de change' },
    { code: '677', libelle: 'Pertes sur cessions de titres de placement' },
    { code: '678', libelle: 'Pertes sur risques financiers' },
    { code: '679', libelle: 'Charges provisionnées financières' },
    { code: '681', libelle: 'Dotations aux amortissements d\'exploitation' },
    { code: '687', libelle: 'Dotations aux amortissements à caractère financier' },
    { code: '691', libelle: 'Dotations aux provisions d\'exploitation' },
    { code: '697', libelle: 'Dotations aux provisions financières' },

    // Classe 7 - Comptes de produits des activités ordinaires
    { code: '701', libelle: 'Ventes de marchandises' },
    { code: '702', libelle: 'Ventes de produits finis' },
    { code: '703', libelle: 'Ventes de produits intermédiaires' },
    { code: '704', libelle: 'Ventes de produits résiduels' },
    { code: '705', libelle: 'Travaux facturés' },
    { code: '706', libelle: 'Services vendus' },
    { code: '707', libelle: 'Produits accessoires' },
    { code: '711', libelle: 'Subventions d\'exploitation sur produits à l\'exportation' },
    { code: '712', libelle: 'Subventions d\'exploitation sur produits à l\'importation' },
    { code: '713', libelle: 'Subventions d\'exploitation sur produits de péréquation' },
    { code: '718', libelle: 'Autres subventions d\'exploitation' },
    { code: '721', libelle: 'Production immobilisée - Immobilisations incorporelles' },
    { code: '722', libelle: 'Production immobilisée - Immobilisations corporelles' },
    { code: '726', libelle: 'Production immobilisée - Immobilisations financières' },
    { code: '734', libelle: 'Variations des stocks de produits en cours' },
    { code: '735', libelle: 'Variations des en-cours de services' },
    { code: '736', libelle: 'Variations des stocks de produits finis' },
    { code: '737', libelle: 'Variations des stocks de produits intermédiaires et résiduels' },
    { code: '752', libelle: 'Quote-part de résultat sur opérations faites en commun' },
    { code: '753', libelle: 'Quote-part de résultat sur exécution partielle de contrats pluri-exercices' },
    { code: '754', libelle: 'Produits des cessions courantes d\'immobilisations' },
    { code: '758', libelle: 'Produits divers' },
    { code: '759', libelle: 'Reprises de charges provisionnées d\'exploitation' },
    { code: '771', libelle: 'Intérêts de prêts' },
    { code: '772', libelle: 'Revenus de participations' },
    { code: '773', libelle: 'Escomptes obtenus' },
    { code: '774', libelle: 'Revenus de titres de placement' },
    { code: '776', libelle: 'Gains de change' },
    { code: '777', libelle: 'Gains sur cessions de titres de placement' },
    { code: '778', libelle: 'Gains sur risques financiers' },
    { code: '779', libelle: 'Reprises de charges provisionnées financières' },
    { code: '781', libelle: 'Transferts de charges d\'exploitation' },
    { code: '787', libelle: 'Transferts de charges financières' },
    { code: '791', libelle: 'Reprises de provisions d\'exploitation' },
    { code: '797', libelle: 'Reprises de provisions financières' },
    { code: '798', libelle: 'Reprises d\'amortissements' },
];

export default OHADA_ACCOUNTS;
